@import "../../global/normalize.css";

/**
* @prop --ic-z-index-popover: z-index of popover menu. 
* @prop --max-height: Maximum height of the popover menu.
* @prop --popover-width: Default width of the popover menu.
*/

@media (prefers-reduced-motion: no-preference) {
  :host .opening-from-parent {
    animation: slide-in var(--ic-transition-duration-slow) ease-in-out;
  }

  :host .opening-from-child {
    animation: slide-out var(--ic-transition-duration-slow) ease-in-out;
  }
}

:host .ic-popover-menu {
  border-radius: var(--ic-border-radius);
  color: var(--ic-popover-nav-text);

  --ic-typography-color: var(--ic-popover-nav-text);

  position: relative;
  z-index: var(--ic-z-index-popover);
  box-sizing: border-box;
  box-shadow: var(--ic-elevation-overlay);
  display: none;
}

:host(.on-dialog) {
  inset: auto !important;
}

:host(.on-dialog-fix-translate) {
  transform: translate(0, var(--ic-space-xs)) !important;
}

:host(.on-dialog-translate-y) {
  transform: translate(0, calc(-1 * var(--translate-y))) !important;
}

.menu {
  border: var(--ic-border-default);
  border-color: var(--ic-popover-border);
  border-radius: var(--ic-border-radius);
  background-color: var(--ic-popover-background);
  visibility: hidden;
  height: 0;
  display: flex;
  flex-direction: column;
}

:host .ic-popover-menu:focus-within {
  box-shadow: var(--ic-border-focus);
}

.menu:focus-visible {
  outline: none;
}

:host .ic-popover-menu-open {
  display: block;
  min-width: calc(20rem - var(--ic-space-xl));
  width: var(--popover-width, 20rem);
  max-width: calc(100vw - var(--ic-space-xl));
}

:host .ic-popover-menu-open .menu {
  visibility: visible;
  height: fit-content;
  max-height: var(--max-height, fit-content);
  overflow-y: auto;
  overflow-x: hidden;
}

.parent-label {
  --ic-typography-color: var(--ic-popover-parent-label);

  margin: var(--ic-space-xs) var(--ic-space-xs) 0;
}

@keyframes slide-in {
  from {
    opacity: 0;
    transform: translateX(10rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slide-out {
  from {
    opacity: 0;
    transform: translateX(-10rem);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}
